/** Hindi: putting the web app on the home screen. */
export const install = {
    "install.title": "GigSync को होम स्क्रीन पर रखें",
    "install.about": "यह ऐप की तरह खुलेगा, नेटवर्क न हो तब भी।",
    "install.button": "ऐप इंस्टॉल करें",
    "install.ios": "शेयर बटन दबाएँ, फिर होम स्क्रीन पर जोड़ने वाला विकल्प चुनें।",
    "install.ios_first": "साइन इन से पहले कर लें: iPhone पर होम स्क्रीन वाला ऐप अपना डेटा Safari से अलग रखता है।",
    "install.later": "अभी नहीं",
    "install.screen": "GigSync इंस्टॉल करें",
    "install.on_iphone": "आपके iPhone पर GigSync",
    "install.on_phone": "आपके फ़ोन पर GigSync",
    "install.on_computer": "आपके कंप्यूटर पर GigSync",
    "install.installed": "GigSync इंस्टॉल है: आप अभी ऐप में ही हैं।",
    "install.ios_share": "शेयर बटन दबाएँ: नीचे तीर वाला चौकोर निशान, या ⋯ के अंदर।",
    "install.other_share": "ऊपर दाईं ओर शेयर दबाएँ, या यह पेज Safari में खोलें।",
    "install.ios_add": "नीचे जाकर होम स्क्रीन पर जोड़ने वाला विकल्प (Add to Home Screen) चुनें।",
    "install.ios_keep": "वेब ऐप की तरह खोलने वाला विकल्प (Open as Web App) चालू रखें, फिर Add दबाएँ।",
    "install.ios_open": "GigSync को होम स्क्रीन से खोलें।",
    "install.ios_apart": "साइन इन से पहले करना अच्छा है: iPhone पर होम स्क्रीन वाला ऐप अपना डेटा Safari से अलग रखता है, इसलिए वहाँ फिर से साइन इन करना होगा।",
    "install.android_menu": "Chrome में ऊपर दाईं ओर ⋮ दबाएँ।",
    "install.android_pick": "ऐप इंस्टॉल करने (Install app) या होम स्क्रीन पर जोड़ने (Add to Home screen) का विकल्प चुनें।",
    "install.android_open": "Install दबाएँ, फिर GigSync को होम स्क्रीन से खोलें।",
    "install.computer_icon": "एड्रेस बार के दाईं ओर इंस्टॉल का निशान दबाएँ, या ⋮ › Cast, save and share › Install page as app चुनें।",
    "install.mac_dock": "Safari के ऊपर वाले मेनू में File › Add to Dock चुनें।",
    "install.computer_add": "Install दबाएँ।",
    "install.mac_add": "Add दबाएँ।",
    "install.computer_open": "GigSync अपनी अलग विंडो में खुलेगा और आपके बाक़ी ऐप्स के साथ दिखेगा।",
};
//# sourceMappingURL=install.js.map